import { render, staticRenderFns } from "./apago.vue?vue&type=template&id=894341ba&scoped=true"
import script from "./apago.vue?vue&type=script&lang=js"
export * from "./apago.vue?vue&type=script&lang=js"
import style0 from "./apago.vue?vue&type=style&index=0&id=894341ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "894341ba",
  null
  
)

export default component.exports